<template>
  <div class="content-game-loading">
    <div class="m-auto text-center">
      <Spinner label="Loading..." class="m-auto spinner-main"></Spinner>
      <br />
      {{ $t("loading") }}
    </div>
  </div>
</template>

<script>
export default {
  async mounted() {
    try {
      const params = new URLSearchParams(window.location.search);
      let to = params.get("to");
      let redirect_Page = () => {
        const params = new URLSearchParams(window.location.search);
        let redirectPath = params.get("redirect");

        if (!this.$store.state.templateReady) {
          this.$store.dispatch("setReady");
        }

        if (window.location.pathname !== "/") return;

        const targetRaw = redirectPath && redirectPath !== "/"
          ? redirectPath
          : "/profile";
        const [targetPath, targetQuery = ""] = targetRaw.split("?");
        const merged = new URLSearchParams(targetQuery);
        params.forEach((value, key) => {
          if (!merged.has(key)) merged.set(key, value);
        });
        const search = merged.toString();
        return this.$router.replace(search ? `${targetPath}?${search}` : targetPath);
      };
      if (this.$liff.id && !to)
        if (this.$appConfig.NODE_ENV != "development") this.liffOpen();
      redirect_Page();
    } catch (error) {
      alert(error + "alert");
      console.error(error);
    }
  },
  methods: {
    async liffOpen() {
      if (!this.$config.isLoginLine) return;
      let isInLine = await this.$liff.isInClient();
      let isMobileDevice = window.matchMedia("(any-pointer: coarse)").matches;
      let getOs = await this.$liff.getOS();
      if (
        !isInLine &&
        isMobileDevice &&
        (getOs == "web" || getOs == "ios" || getOs == "android")
      ) {
        setTimeout(() => {
          if (this.$route.path) {
            window.location.href = `line://app/${this.$liffId}?redirect=${window.location.pathname}${window.location.search}`;
          } else {
            window.location.href = `line://app/${this.$liffId}/${window.location.pathname}${window.location.search}`;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style>
.content-game-loading {
  height: 100dvh;
  /* position: absolute; */
  top: 0;
  width: 100%;
  /* background: white; */
  z-index: 1;
  display: flex;
}
</style>
